module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "ui modal"
  }, [_vm._h('div', {
    staticClass: "header"
  }, ["Upload"]), " ", _vm._h('div', {
    staticClass: "content"
  }, [_vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploading),
      expression: "uploading"
    }],
    ref: "progress",
    staticClass: "ui progress"
  }, [_vm._m(0), " ", _vm._h('div', {
    staticClass: "label"
  }, ["Uploading..."])]), " ", _vm._h('br'), " ", _vm._h('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.selectedFile
    }
  }), " ", _vm._h('div', {
    staticClass: "ui blue button",
    on: {
      "click": function($event) {
        _vm.$refs.file.click()
      }
    }
  }, ["Select File"]), " ", _vm._h('div', {
    staticClass: "ui red button",
    on: {
      "click": _vm.close
    }
  }, ["Close"])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "bar"
  }, [_vm._h('div', {
    staticClass: "progress"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-feb9e982!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadModal.vue
// module id = 245
// module chunks = 2